// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._35aU8{display:grid;grid-template-areas:\"heading figure\" \"content figure\";grid-template-columns:7fr 5fr;grid-column-gap:1rem;-webkit-column-gap:1rem;-moz-column-gap:1rem;column-gap:1rem}@media(max-width:767px){._35aU8{grid-template-columns:auto;grid-template-areas:\"heading\" \"figure\" \"content\"}}.b9pVd{grid-area:heading;margin-bottom:2rem}@media(min-width:768px){.b9pVd{-ms-flex-item-align:end;align-self:flex-end}}@media(max-width:767px){.b9pVd{margin-bottom:1.5rem}}._2nTCf{grid-area:content}._1KETH{margin-bottom:2rem;font-size:16px;font-weight:300;line-height:26px;font-family:var(--base-font)}@media(max-width:767px){._1KETH{margin-bottom:1.5rem}}.XJCG-{display:-ms-flexbox;display:flex}.XJCG-:not(:last-child){margin-bottom:1rem}._1f6ht{-ms-flex-negative:0;flex-shrink:0;margin-right:1rem}._1f6ht path{fill:#00d8ae}.R0Bc1{grid-area:figure}@media(max-width:767px){.R0Bc1{margin-bottom:1rem}}.R0Bc1 img{border-radius:.25rem}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "_35aU8",
	"heading": "b9pVd",
	"content": "_2nTCf",
	"list": "_1KETH",
	"item": "XJCG-",
	"icon": "_1f6ht",
	"figure": "R0Bc1"
};
module.exports = exports;
